 import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { APIVersion } from './types';

export const API_ROOT_URL = 'https://nodejs.bible.com/api/bible';

export const youversion = createApi({
  reducerPath: 'youversion',
  baseQuery: fetchBaseQuery({
    baseUrl: API_ROOT_URL
  }),
  endpoints: builder => ({
    getVersions: builder.query<APIVersion[], string>({
      query: (language: string = 'eng') => `versions/3.1?language_tag=${language}&type=all`,
      transformResponse: (response: { versions: APIVersion[] }) => response.versions
    })
  })
});

export const { useGetVersionsQuery } = youversion;

export function decodeContent(encoded: Uint8Array): string {
  const bArr = [...encoded];
  const i = bArr.length;
  let i2 = 0;
  while (i2 < i) {
    if (i > i2 + 1) {
      // do something
      const b = (((bArr[i2 + 1] & 255) >> 5) | ((bArr[i2 + 1] & 255) << 3)) & 255;
      bArr[i2 + 1] = (((bArr[i2] & 255) >> 5) | ((bArr[i2] & 255) << 3)) & 255;
      bArr[i2] = b;
    }
    else {
      // do something else
      bArr[i2] = (((bArr[i2] & 255) >> 5) | ((bArr[i2] & 255) << 3)) & 255;
    }
    i2 += 2;
  }

  return new TextDecoder().decode(new Uint8Array(bArr));
}

export const extractVerseData = (content: string) => {
  const result: Record<string, string> = {};

  const parser = new DOMParser();
  const parsedContent = parser.parseFromString(content, 'text/html');

  const verses: NodeListOf<HTMLElement> = parsedContent.documentElement.querySelectorAll('.verse[data-usfm]');

  verses.forEach(verse => {
    const usfm: string = verse.dataset.usfm!;

    let contentString = '';

    verse.querySelectorAll('.content').forEach(
      (c) => contentString += c.textContent
    );

    if (result[usfm]) {
      result[usfm] += ' ' + contentString;
    }
    else {
      result[usfm] = contentString;
    }
  });

  return result;
};
